<template>
    <div>
        <!-- Step 1 -->
        <transition name="fade" mode="out-in">
            <div v-if="step == 1">
                <h4 class="mb-2">Calcolo Retta</h4>
                <form>
                    <div class="p-4 bg-white border rounded">
                       
                        <!-- Ateneo -->
                        <div class="row mb-2">
                            <label for="course" class="col-md-4 col-form-label text-md-end">Ateneo</label>
                            <div class="col-12 col-md-8">
                                <select
                                    class="form-select"
                                    aria-label="Ateneo"
                                    v-model="form.from"
                                    required
                                    @change="changeUniversity">
                                        <option :value="null" disabled>Seleziona...</option>
                                        <option value="PEGASO">Università Telematica Pegaso</option>
                                        <option value="MERCATORUM">Universitas Mercatorum</option>
                                        <option value="SANRAFFAELE">Università Telematica San Raffaele Roma</option>
                                </select>
                            </div>
                        </div>

                        <!-- Corso di Laurea -->
                        <div class="row mb-2">
                            <label for="course" class="col-md-4 col-form-label text-md-end">Corso di Laurea</label>
                            <div class="col-12 col-md-8">
                                <select
                                    class="form-select"
                                    aria-label="Corso di Laurea"
                                    id="course"
                                    v-model="form.course"
                                    required
                                    :disabled="!form.from"
                                    @change="changeCourse"
                                >
                                    <option :value="null" disabled>Seleziona...</option>
                                    <option v-for="(course, index) in helpers.courses" :key="index" :value="course">
                                        {{ course.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Tipo di Ingresso -->
                        <div class="row mb-2">
                            <label for="entrance" class="col-md-4 col-form-label text-md-end">Tipo di Ingresso</label>
                            <div class="col-12 col-md-8">
                                <select class="form-select" aria-label="Tipo di Ingresso" id="entrance" v-model="form.entrance" required>
                                    <option :value="null" disabled>Seleziona...</option>
                                    <option v-for="(entrance, index) in helpers.entrances" :key="index" :value="entrance">
                                        {{ entrance.label }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Anno Accademico -->
                        <div class="row mb-2">
                            <label for="aa" class="col-md-4 col-form-label text-md-end">Anno Accademico</label>
                            <div class="col-12 col-md-8">
                                <select
                                    class="form-select"
                                    aria-label="Anno Accademico"
                                    id="aa"
                                    v-model="form.aa"
                                    required
                                    :disabled="!form.course"
                                    @change="changeAA"
                                >
                                    <option :value="null" disabled>Seleziona...</option>
                                    <option value="2026/2027">2026/2027</option>
                                </select>
                            </div>
                        </div>

                        <!-- Piano di Studi -->
                        <div class="row mb-2">
                            <label for="careers" class="col-md-4 col-form-label text-md-end">Piano di Studi</label>
                            <div class="col-12 col-md-8">
                                <select 
                                    class="form-select" 
                                    aria-label="Piano di Studi" 
                                    id="careers" 
                                    v-model="form.pds" 
                                    :disabled="!form.aa"
                                    @change="getConventions()" 
                                    required>
                                        <option :value="null" disabled>Seleziona...</option>
                                        <option v-for="(career, index) in helpers.careers" :key="index" :value="career">
                                            {{ career.label }}
                                        </option>
                                </select>
                            </div>
                        </div>

                        <!-- Agevolazione -->
                        <div class="row mb-2">
                            <label for="convention" class="col-md-4 col-form-label text-md-end">Agevolazione</label>
                            <div class="col-12 col-md-8">
                                <select 
                                    class="form-select" 
                                    v-model="form.convention" 
                                    :disabled="!form.pds"
                                    required
                                    @change="getPrograms(); getCompanies()">
                                        <option :value="null" disabled>Seleziona...</option>
                                        <option v-for="(convention, index) in helpers.conventions" :key="index" :value="convention">
                                            {{ convention.label }}
                                        </option>
                                </select>
                            </div>
                        </div>

                        <!-- Enti/Aziende -->
                        <div class="row mb-2" v-if="helpers.companies.length > 0 && this.form.convention && this.form.convention.label != 'ALTRI ENTI'">
                            <label for="convention" class="col-md-4 col-form-label text-md-end">Enti/Aziende</label>
                            <div class="col-12 col-md-8">
                                <select 
                                    class="form-select" 
                                    v-model="form.company">
                                        <option :value="null" disabled>Seleziona...</option>
                                        <option v-for="(company, index) in helpers.companies" :key="index" :value="company">
                                            {{ company.label }}
                                        </option>
                                </select>
                            </div>
                        </div>

                        <!-- Programma -->
                        <div class="row mb-2">
                            <label for="program" class="col-md-4 col-form-label text-md-end">Formula</label>
                            <div class="col-12 col-md-8">
                                <select 
                                    class="form-select" 
                                    v-model="form.program" 
                                    :disabled="!form.convention"
                                    required
                                    @change="changeProgram">
                                        <option :value="null" disabled>Seleziona...</option>
                                        <option v-for="(program, index) in helpers.programs" :key="index" :value="program">
                                            {{ program.label }}
                                        </option>
                                </select>
                            </div>
                        </div>

                        <!-- Rate -->
                        <div class="row mb-2">
                            <label for="installment" class="col-md-4 col-form-label text-md-end">Rate</label>
                            <div class="col-12 col-md-8">
                                <select
                                    class="form-select"
                                    aria-label="Rate"
                                    id="installment"
                                    v-model="form.installments"
                                    @change="getImport"
                                    :disabled="!form.aa || !form.program"
                                    required
                                >
                                    <option :value="null" disabled>Seleziona...</option>
                                    <option v-for="installment in helpers.installments" :key="installment.value"
                                            :value="{ id: installment.id, label: installment.label }">
                                        {{ installment.label }}
                                    </option>
                                </select>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
    import * as services from '../../services';

    export default {
        props: {
            step: null,
        },
        data() {
            return {
                form: {
                    fiscal_code: 'RSSMRA80A01F205X',
                    from: null,
                    course: null,
                    aa: null,
                    pds: null,
                    label: '',
                    convention: null,
                    program: null,
                    installments: null,
                    promo_code: null,
                    entrance: null
                },
                helpers: {
                    courses: [],
                    careers: [],
                    labels: [],
                    conventions: [],
                    programs: [],
                    installments: [],
                    companies: [],
                    entrances: []
                }
            }
        },
        methods: {
            async changeUniversity () {
                console.log('changeUniversity')
                this.form.course = null
                this.form.aa = null
                this.form.pds = null
                this.form.label = ''
                this.form.convention = null
                this.form.program = null
                this.form.installments = null
                this.form.promo_code = null
                this.form.company = null
                const urls = {
                    'PEGASO': 'https://orienta.pegaso.multiversity.click',
                    'MERCATORUM': 'https://orienta.mercatorum.multiversity.click',
                    'SANRAFFAELE': 'https://orienta.utsr.multiversity.click'
                }
                this.$store.dispatch('settings/setEcpPlatform', urls[this.form.from])
                await this.getCourses()
            },  
            async getCourses() {
                const data = await services.ecp.post('api/get/graduate/courses')
                const excludedCodes = ["02GIURI", "040", "015", "003"];
                this.helpers.courses = data.data
                    .filter(el => !excludedCodes.includes(el.code))
                    .map(el => {
                        return {
                            name: el.name,
                            code: el.code
                        };
                    });
            },
            async changeCourse() {
                console.log('changeCourse')
                const lm = ['01SCUMA', '031', '038', '03SCUMA', '04GIURI', '051', '052', '059', '05SCUMA', '061', '066', '067', '06GIURI', '077', '07SCUMA', '063', '037', '032']
                const code = this.form.course.code 
                if (code == '00GIURI') {
                    this.form.course.duration = 5
                } else if (lm.includes(code)) {
                    this.form.course.duration = 2
                } else {
                    this.form.course.duration = 3
                }
                this.$store.dispatch('summary/setCourse', this.form.course)
                this.form.aa = null
                this.form.pds = null
                this.form.label = ''
                this.form.convention = null
                this.form.program = null
                this.form.installments = null
                this.form.promo_code = null
                this.form.prospects = null
                this.form.company = null
                this.form.entrance = null
                await this.getEntrance()
            },
            async getEntrance() {
                const data = await services.ecp.post('api/get/graduate/tipo/ingresso', {
                    courseCode: this.form.course.code
                });
                this.helpers.entrances = data.data.map(el => {
                    return {
                        label: el.DESCRIZIONE,
                        id: el.ID_TIPO_INGRESSO
                    }
                })
            },
            async getCareers() {
                console.log('getCareers')
                this.helpers.careers = null
                this.helpers.labels = []
                const careers = await services.ecp.post('api/get/graduate/careers', {
                    course_code: this.form.course.code,
                    academicYear: this.form.aa
                })
                this.helpers.careers = careers.data.map(el => {
                    return {
                        label: el.name,
                        id: el.id
                    }
                })
            },
            async changeAA() {
                console.log('changeAA')
                this.form.pds = null
                this.form.label = ''
                this.form.convention = null
                this.form.program = null
                this.form.installments = null
                this.form.promo_code = null
                this.form.prospects = null
                this.form.company = null
                await this.getCareers()
            },
            async getConventions() 
            {
                console.log('getConventions')
                let data
                data = await services.ecp.post('api/get/graduate/conventions', {
                    aa: this.form.aa
                })

                let descriptions = {
                    'STANDARD': null,
                    'ENTI CONVENZIONATI': 'Agevolazione riservata agli iscritti/dipendenti di un ente convenzionato con l\'Ateneo (es. sindacati, categorie di rappresentanza).',
                    'MULTIVERSITY CARD': 'Agevolazione riservata agli studenti che intendono iscriversi a un corso di laurea dell\'Ateneo.',
                    'MULTIVERSITY CARD - START': 'Agevolazione riservata agli studenti che si immatricolano al primo anno di un corso di laurea triennale o magistrale a ciclo unico, anche con riconoscimento di crediti formativi universitari (CFU).',
                    'FUTURO SICURO': 'Agevolazione riservata ai giovani studenti d\'età compresa tra i 17 e i 21 anni che si iscrivono al primo anno di un corso di laurea triennale o magistrale a ciclo unico (anche con riconoscimento di CFU).',
                    'FORZE ARMATE E FORZE DELL\'ORDINE': 'Agevolazione riservata al personale in servizio militare permanente all’interno di uno dei Corpi delle Forze Armate e Forze dell’Ordine, ai prossimi congiunti (coniuge e figli) del personale attualmente in servizio, nonché ai conviventi e figli regolati dalla L. 20/5/2016, n. 76 (Unioni Civili). La medesima agevolazione è estesa anche al personale in congedo (personale in pensione).',
                    'PUBBLICA AMMINISTRAZIONE': 'Agevolazione dedicata ai dipendenti della Pubblica Amministrazione e ai prossimi congiunti (coniuge e figli).',
                    'CATEGORIE TUTELATE': 'Agevolazione riservata agli studenti con Disturbi Specifici di Apprendimento, a donne in gravidanza e a neo genitori con figli dai 0 ai 24 mesi.',
                    'AZIENDE CONVENZIONATE': 'Agevolazione riservata ai dipendenti di un\'azienda convenzionata con l\'Ateneo.',
                    'DOPPIA LAUREA': 'Agevolazione riservata agli studenti che scelgono di frequentare due corsi di laurea in contemporanea (sia all\'interno dell\'Ateneo che combinando l\'iscrizione con un altro istituto universitario).',
                    'INVALIDITA\' > 45%': 'Agevolazione riservata agli studenti con disabilità certificata maggiore del 45%.'
                }
                
                this.helpers.conventions = data.data.map(el => {
                    return {
                        label: el.name.toUpperCase().replace('26/27 - ', ''),
                        real_id: el.id,
                        id: el.id,
                        description: descriptions[el.name] ? descriptions[el.name] : null
                    }
                })

                if (this.form.course.code == '013') { // L-13 Scienze Biologiche
                    this.helpers.conventions = this.helpers.conventions.filter(el => el.label === 'SCIENZE BIOLOGICHE');
                } else if (this.form.course.duration >= 3) { // Triennali
                    let multiversity_card = this.helpers.conventions.find(el => el.label == 'MULTIVERSITY CARD' || el.label == 'MULTIVERSITY')
                    this.helpers.conventions.push({
                        label: 'MULTIVERSITY CARD - START',
                        real_id: multiversity_card.real_id,
                        id: 999999,
                        description: descriptions['MULTIVERSITY CARD - START'] ? descriptions['MULTIVERSITY CARD - START'] : null
                    })
                    if (this.form.course.code == '016') {
                        this.helpers.conventions = this.helpers.conventions.filter(el => el.label != 'SCIENZE BIOLOGICHE');
                    } else {
                        this.helpers.conventions = this.helpers.conventions.filter(el => el.label != 'SCIENZE BIOLOGICHE' && !el.label.includes('FOOTBALL MANAGEMENT'));
                    }
                    
                } else {
                    this.helpers.conventions = this.helpers.conventions.filter(el => el.label != 'FUTURO SICURO' && el.label != 'SCIENZE BIOLOGICHE' && !el.label.includes('FOOTBALL MANAGEMENT'));
                }
            },
            async getCompanies() 
            {
                console.log('getCompanies')
                this.form.company = null
                const data = await services.ecp.post('api/get/graduate/companies', {
                    convention_id: this.form.convention.id
                })
                this.helpers.companies = data.data.map(el => {
                    return {
                        label: el.name.toUpperCase(),
                        id: el.id
                    }
                })
            },    
            async getPrograms() 
            {
                console.log('getPrograms')

                this.form.program = null
                this.form.prospect = null
                this.form.prospect_next = null
                this.form.installments = null
                this.helpers.installments = []

                const data = await services.ecp.post('api/get/graduate/programs', {
                    convention_id: this.form.convention.real_id,
                    label: this.form.label,
                    academicYear: this.form.aa,
                    category_code: this.form.course ? this.form.course.code : null
                })

                this.helpers.programs = data.data.map(el => {
                    return {
                        label: el.name.toUpperCase(),
                        id: el.id,
                        promo_code: !!el.promo_code,
                    }
                })

                this.helpers.programs.sort((a, b) => a.label.localeCompare(b.label));
            },
            async changeProgram()
            {
                console.log('changeProgram')
                await this.getInstallments()
            },  
            async getLabels()
            {
                console.log('getLabels')
                const labels = await services.ecp.post('api/get/graduate/labels', {
                    course_code: this.form.course.code,
                    academicYear: this.form.aa,
                    program_id: this.form.program.id,
                    convention_id: this.form.convention.id
                })
                this.helpers.labels = labels.data
            },
            async getInstallments() 
            {
                console.log('getInstallments')                    
                const promo_code = this.$getPromoCode(this.form, this.form.from)
                if (promo_code != '') {
                    const dataPromo = await services.ecp.post('api/check-promo-code', {
                        promo_code: promo_code,
                        fiscal_code: 'RSSMRA80A01F205X',
                        course_code: this.form.course.code,
                        convention_id: this.form.convention.real_id,
                        program_id: this.form.program.id,
                        academicYear: this.form.aa,
                    });
                    const elPromo = dataPromo.data
                    this.form.supplement_program_id = elPromo.supplement_program_id
                }
                this.form.promo_code = promo_code

                this.helpers.installments = []
                this.form.installments = null
                const data = await services.ecp.post('api/get/graduate/installments', {
                    convention_id: this.form.convention.real_id,
                    program_id: this.form.program.id
                })
                this.helpers.installments = data.data.map(el => {
                    return {
                        label: el.num_rate,
                        id: el.id
                    }
                })
            },      
            async getImport() 
            {
                console.log('getImport')

                const promo_codes_start = {
                    'BASE 26_27': 'START BASE 2627 PROMOBACKTOUNI',
                    'FULL ACCESS 26_27': 'START FULL ACCESS 2627 PROMOBACKTOUNI',
                    'FULL ACCESS PLUS 26_27': 'START FULL ACCESS PLUS 2627 PROMOBACKTOUNI'
                }

                const data = await services.ecp.post('api/get/graduate/prospectus', {
                    academicYear: this.form.aa,
                    label: "",
                    program: this.form.program.id,
                    installments: this.form.installments.id,
                    course_code: this.form.course.code,
                    convention_id: this.form.convention.real_id,
                    promo_code: this.form.promo_code,
                    fiscal_code: this.form.fiscal_code,
                })
                this.form.prospect = data.data
                const prospectus_next = await services.ecp.post('api/get/graduate/sub-prospectus', {
                    academicYear: this.form.aa,
                    label: "",
                    program: this.form.program.id,
                    installments: this.form.installments.id,
                    course_code: this.form.course.code,
                    convention_id: this.form.convention.real_id,
                    promo_code: this.form.promo_code,
                    fiscal_code: this.form.fiscal_code,
                })
                this.form.prospect_next = prospectus_next.data;

                for (let i=0; i<this.helpers.programs.length; i++) {

                    let p = this.helpers.programs[i]

                    // prospetto primo anno
                    let prospetto_first_year = await services.ecp.post('api/get/graduate/prospectus', {
                        academicYear: this.form.aa,
                        label: "",
                        program: p.id,
                        installments: this.form.installments.id,
                        course_code: this.form.course.code,
                        convention_id: this.form.convention.real_id,
                        promo_code: this.form.convention.label == 'MULTIVERSITY CARD - START' ? promo_codes_start[p.label] : this.form.promo_code,
                        fiscal_code: this.form.fiscal_code,
                    })
                    let el_first_year = prospetto_first_year.data
                    if (el_first_year.program.is_base == 1) {
                        this.form.imports['BASE']['FIRST_YEAR']['import'] = el_first_year.program.import 
                        this.form.imports['BASE']['FIRST_YEAR']['prospectus'] = el_first_year.prospectus
                    } else if (el_first_year.program.is_all_inclusive == 1) {
                        this.form.imports['FULL_ACCESS']['FIRST_YEAR']['import'] = el_first_year.program.import 
                        this.form.imports['FULL_ACCESS']['FIRST_YEAR']['prospectus'] = el_first_year.prospectus
                    } else if (el_first_year.program.is_full_access_plus == 1) {
                        this.form.imports['FULL_ACCESS_PLUS']['FIRST_YEAR']['import'] = el_first_year.program.import 
                        this.form.imports['FULL_ACCESS_PLUS']['FIRST_YEAR']['prospectus'] = el_first_year.prospectus
                    }

                    // prospetto altri anni
                    let prospetto_other_years = await services.ecp.post('api/get/graduate/sub-prospectus', {
                        academicYear: this.form.aa,
                        label: "",
                        program: p.id,
                        installments: this.form.installments.id,
                        course_code: this.form.course.code,
                        convention_id: this.form.convention.real_id,
                        promo_code: this.form.convention.label == 'MULTIVERSITY CARD - START' ? promo_codes_start[p.label] : this.form.promo_code,
                        fiscal_code: this.form.fiscal_code,
                    })
                    let el_other_years = prospetto_other_years.data
                    if (el_other_years.program.is_base == 1) {
                        this.form.imports['BASE']['OTHER_YEARS']['import'] = el_other_years.program.import 
                        this.form.imports['BASE']['OTHER_YEARS']['prospectus'] = el_other_years.prospectus
                    } else if (el_other_years.program.is_all_inclusive == 1) {
                        this.form.imports['FULL_ACCESS']['OTHER_YEARS']['import'] = el_other_years.program.import 
                        this.form.imports['FULL_ACCESS']['OTHER_YEARS']['prospectus'] = el_other_years.prospectus
                    } else if (el_other_years.program.is_full_access_plus == 1) {
                        this.form.imports['FULL_ACCESS_PLUS']['OTHER_YEARS']['import'] = el_other_years.program.import 
                        this.form.imports['FULL_ACCESS_PLUS']['OTHER_YEARS']['prospectus'] = el_other_years.prospectus
                    }
                }
            },
        },
        mounted() {
            this.form.imports = {
                'BASE': {
                    'FIRST_YEAR': {'import': null, 'prospectus': []},
                    'OTHER_YEARS': {'import': null, 'prospectus': []}
                },
                'FULL_ACCESS': {
                    'FIRST_YEAR': {'import': null, 'prospectus': []},
                    'OTHER_YEARS': {'import': null, 'prospectus': []}
                },
                'FULL_ACCESS_PLUS': {
                    'FIRST_YEAR': {'import': null, 'prospectus': []},
                    'OTHER_YEARS': {'import': null, 'prospectus': []}
                }
            }
            this.form.prospects = {
                'BASE': {
                    'NOLABEL': null,
                    'LABEL': null
                },
                'AI': {
                    'NOLABEL': null,
                    'LABEL': null
                }
            }
        },
        watch: {
            'form.installments' (val) {
                if (val) {
                    this.$store.dispatch('summary/setRate', val.label)
                } else {
                    this.$store.dispatch('summary/setRate', null)
                }
            },
            'form.prospects' (val) {
                if (val) {
                    this.$store.dispatch('summary/setRecap', val)
                }
            },
            'form.program' (val) {
                if (val) {
                    this.$store.dispatch('summary/setProgram', val.label == 'BASE' ? 'BASE' : 'AI')
                }
            },
            'form.label' (val) {
                this.$store.dispatch('summary/setLabel', !val || val == '' ? 'NOLABEL' : 'LABEL')
            },
            form: {
                handler(val) {
                    this.$store.dispatch('summary/setForm', val)
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .border-primary {
        border-color:#a71d23 !important;
    }
    .btn-outline-primary {
        border-color:#a71d23 !important;
        color:#a71d23 !important;
    }
    .btn-outline-primary:hover {
        color: #fff!important;
        background-color: #a71d23 !important;
    }
    .btn-primary {
        color: #fff!important;
        background-color: #a71d23 !important;
        border-color:#a71d23 !important;
    }
</style>